export function xhr(method, path, data) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open( method, path, true );
        xhr.responseType = 'json';
        xhr.onreadystatechange = function() {
            if (xhr.readyState !== 4) return;

                if (xhr.response) {
                    resolve(xhr.response);
                }

            if (xhr.status !== 200) {
                reject(xhr.status + ': ' + xhr.statusText);
            } else {
                reject(xhr.response);
            }
        };

        if (data) {
            xhr.send(data);
        } else {
            xhr.send();
        }
    });
}


export function loaderStart() {
    loaderToggle(true);
}


export function loaderStop() {
    loaderToggle(false);
}


export function loaderToggle(conditiont) {
    const element = document.querySelector('.loader');

    if (element) {
        element.classList.toggle('_show', conditiont);

        document.body.style.overflow = conditiont ? "hidden" : "";
    }
}
